import axios from 'axios';

async function ObtenerProvincias(prmIdPais: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_provincias"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "idPais": prmIdPais
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerProvincias;